export const BROAD_CASTER_MAP = {
  AL: {
    url: 'https://rtsh.al/festivali/njoftimi-i-privatesise-per-televotimin-e-eurovision-song-contest-2026/',
    name: 'Radio Televizioni Shqiptar (RTVSH)',
  },
  AM: {
    url: 'https://www.eurovision.am/hy/eurovision/data',
    name: 'Հայաստանի Հանրային Հեռուստաընկերություն (1TV)',
  },
  AU: {
    url: 'https://www.sbs.com.au/whats-on/article/2026-eurovision-song-contest-paid-online-voting-privacy-notice/r1n22pyt9',
    name: 'Special Broadcasting Service (SBS)',
  },
  AT: {
    url: 'https://www.srf.ch/sendungen/eurovision-song-contest/rechtliches-datenschutzhinweise-fuer-kostenpflichtiges-onlinevoting-esc-2026',
    name: 'Österreichischer Rundfunk (ORF)',
  },
  AZ: {
    url: 'https://itv.az/eurovision?season=21',
    name: 'İctimai (ITV)',
  },
  BE: {
    url: 'https://www.rtbf.be/article/eurovision2024-comment-voter-pour-votre-candidatfavori-11359477%250D%250D',
    name: 'Radio-Télévision Belge de la Communauté Française (RTBF)',
  },
  BG: {
    url: 'https://eurovision2026.bg/privacy',
    name: 'Bulgarian National Television (BNT)',
  },
  HR: {
    url: 'https://magazin.hrt.hr/ZABAVA/KAKO-SE-OBRADUJU-I-STITE-VASI-PODACI-TIJEKOM-GLASOVANJA-ZA-EUROSONG-2026--12669507',
    name: 'Hrvatska Radiotelevizija (HRT)',
  },
  CY: {
    url: 'https://corporate.rik.cy/eurovision-2026-privacy-policy/',
    name: 'Ραδιοφωνικό Ίδρυμα Κύπρου (CyBC)',
  },
  CZ: {
    url: 'https://www.ceskatelevize.cz/porady/10000000484-eurovision-song-contest/13794-pravidla-hlasovani/',
    name: 'Česká televize (CT)',
  },
  DK: {
    url: 'https://www.dr.dk/event/melodigrandprix/beskyttelse-af-personoplysninger-ifm-deltagelse-i-afstemning-ved-eurovision-1',
    name: 'Danmarks Radio (DR)',
  },
  EE: {
    url: 'https://eeter.err.ee/923339/isikuandmete-kaitse-eurovisiooni-lauluvoistluse-telefonihaaletusel',
    name: 'Eesti Rahvusringhääling (ETV)',
  },
  FI: {
    url: 'https://yle.fi/a/74-20222892',
    name: 'Yleisradio Oy (YLE)',
  },
  FR: {
    url: 'https://www.francetelevisions.fr/et-vous/notre-tele/eurovision-2026-reglement-et-modalites-du-vote-54926',
    name: 'France Télévisions (FTV)',
  },
  GE: {
    url: 'https://1tv.ge/evrovizia-georgia/monacemta-dacva/',
    name: 'Georgian Public Broadcaster (GPB)',
  },
  DE: {
    url: 'https://www.eurovision.de/Datenschutzbestimmungen-Televoting-ESC-2026,datenschutz-206.html',
    name: 'Südwestrundfunk (SWR)',
  },
  GR: {
    url: 'https://eurovision.ert.gr/privacy-notice/',
    name: 'Ελληνική Ραδιοφωνία Τηλεόραση (ERT)',
  },
  IL: {
    url: 'https://www.kan.org.il/content-pages/privacy',
    name: 'כאן (Kan)',
  },
  IT: {
    url: 'https://www.rai.it/regolamenti/news/2017/04/Eurovision-Song-Contest-7e282c8e-d233-41ff-b55d-f2d9e978578a.html',
    name: 'Radiotelevisione italiana (RAI)',
  },
  LV: {
    url: 'https://www.lsm.lv/raksts/kultura/izklaide/17.04.2026-pazinojums-par-konfidencialitati-2026-gada-eirovizijas-dziesmu-konkursa-tiessaistes-balsosana.a643394/',
    name: 'Latvijas Televīzija (LSM)',
  },
  LT: {
    url: 'https://www.lrt.lt/projektai/eurovizija/privatumo-politika',
    name: 'Lietuvos nacionalinis radijas ir televizija (LRT)',
  },
  LU: {
    url: 'https://eurovision.rtl.lu/voting-privacy',
    name: 'RTL Télé Lëtzebuerg (RTL)',
  },
  MT: {
    url: 'https://tvmnews.mt/news/avviz-ta-privatezza-dwar-it-televoting/',
    name: 'Public Broadcasting Services Limited (PBS)',
  },
  MD: {
    url: 'https://trm.md/ro/notificare-de-confidentialitate-privind-votul-online-contra-cost-pentru-eurovision-song-contest-2026',
    name: 'The Broadcasting Company Teleradio-Moldova (TRM)',
  },
  ME: {
    url: 'https://rtcg.me/magazin/eurosong/eurosong2025/839247/obavjestenje-o-privatnosti-za-glasanje-na-takmicenju-za-pjesmu-evrovizije-2026-godine.html',
    name: 'Radio Televizija Crne Gore (RTCG)',
  },
  NO: {
    url: 'https://www.nrk.no/mgp/personvernerklaering-for-telefon--og-nettavstemning_i-eurovision-song-contest-2026-1.14505006',
    name: 'Norsk rikskringkasting (NRK)',
  },
  PL: {
    url: 'https://eurowizja.tvp.pl/',
    name: 'Telewizja Polska (TVP)',
  },
  PT: {
    url: 'https://media.rtp.pt/festivaldacancao/notas-protecao-dados-participacao-no-televoto-voto-online-do-eurovision-song-contest/',
    name: 'Rádio e Televisão de Portugal (RTP)',
  },
  RO: {
    url: 'https://eurovisionromania.ro/NOTIFICARE-PRIVIND-CONFIDENTIALITATEA-PENTRU-TELEVOTING/',
    name: 'Televiziunea Română (TVR)',
  },
  RS: {
    url: 'https://www.rts.rs/rts/pesma-evrovizije/pesma-evrovizije-2025/vesti/5926948/obavestenje-o-privatnosti-za-teleglsanjena-takmicenju-za-pesmu-evrovizije-2026.html%250D%250Dhttps:/www.rts.rs/rts/pesma-evrovizije/pesma-evrovizije-2025/vesti/5926944/obavestenje-o-privatnosti-za-placenonlajn-glasanje-na-takmicenju-za-pesmu-evrovizije-2026.html',
    name: 'Радио-телевизија Србије (RTS)',
  },
  SE: {
    url: 'https://www.svt.se/kontakt/behandling-av-personuppgifter-vid-betald-online-rostning',
    name: 'Sveriges Television (SVT)',
  },
  CH_DE: {
    url: 'https://www.srf.ch/sendungen/eurovision-song-contest/rechtliches-datenschutzhinweise-fuer-kostenpflichtiges-onlinevoting-esc-2026',
    name: 'Schweizer Radio und Fernsehen (SRF, Deutsch)',
  },
  CH_FR: {
    url: 'https://www.rts.ch/dossiers/eurosong/2024/article/avis-de-confidentialite-pour-le-vote-en-ligne-online-voting-esc-2024-28486459.html',
    name: 'Radio Télévison Suisse (RTS, Français)',
  },
  CH_IT: {
    url: 'https://www.rsi.ch/cultura/musica/Informativa-sulla-protezione-dei-dati-per-la-partecipazione-al-televoto-e-Voto-Online-per-l%E2%80%99Eurovision-Song-Contest--1813913.html',
    name: 'Radiotelevisione svizzera di lingua italiana (RSI, Italiano)',
  },
  UA: {
    url: 'https://eurovision.ua/dokumenty/8173-povidomlennya-pro-zahyst-osobystoyi-informatsiyi-u-zvyazku-z-platnym-onlajn-golosuvannyam-na-pisennomu-konkursi-yevrobachennya-2026/',
    name: 'Суспільне (PBC)',
  },
  GB: {
    url: 'https://www.bbc.co.uk/programmes/articles/4ZhPML769CwJhjcbjrsVDLG/eurovision-song-contest-2026-privacy-notice',
    name: 'British Broadcasting Corporation (BBC)',
  },
}
